import _ from "lodash";
import { getMessageGroupsRef } from "db"
import { getMessagesRef } from "db";
import { showAlertAction } from "./ui";
import { updateMessage } from "db";
import { createMessage } from "db";
import { getUsers } from "helpers/https";

export const FETCH_MESSAGE_GROUPS = "fetch message groups";
export const FETCH_MESSAGES_IN_A_GROUP = "fetch messages in a group";
export const FETCH_MESSAGE_USERS = "fetch message users";

// Getting all my message groups
export const getMessageGroupsAction = (uid) => dispatch => {
  return getMessageGroupsRef(uid)
    .onSnapshot(colSnap => {
      dispatch({
        type: FETCH_MESSAGE_GROUPS,
        payload: colSnap.docs
      })
    }, e => {
      console.log(e);
      dispatch(showAlertAction({
        message: "메시지 그룹을 가져오는데 문제가 있습니다. 잠시후 다시 시도해주세요",
        color: 'danger',
      }))
    })
}

// Getting messages of a message group
// When lastMessageId is null, it will load the latest.
// When lastMessageId is set, it will load the messages after the lastMessageId.
export const getMessagesAction = (messageGroupId, lastMessageDocSnap) => dispatch => {
  return getMessagesRef(messageGroupId, lastMessageDocSnap)
    .onSnapshot(colSnap => {
      dispatch({
        type: FETCH_MESSAGES_IN_A_GROUP,
        payload: {
          message_group_id: messageGroupId,
          messages: _.reverse(colSnap.docs)
        }
      })
    }, e => {
      dispatch(showAlertAction({
        message: "메시지를 가져오는데 문제가 있습니다. 잠시후 다시 시도해주세요",
        color: 'danger',
      }))
    })
}

// Save messsage
export const saveMessageAction = (message_group_id, message_id, params) => dispatch => {
  if (message_id) {
    return updateMessage(message_group_id, message_id, params);
  } else {
    return createMessage(message_group_id, params);
  }
}

// Get user list
export const getMessageUsersAction = () => (dispatch, getState) => {
  const { orgs = [] } = getState().org;
  return getUsers()
    .then(user_groups => {
      const message_users = Object.entries(user_groups)
        .map(([key, users]) => {
          let title;
          if (key === 'admin') {
            title = "기관장들"
          } else {
            const currentOrg = _.find(orgs, { id: key });
            title = currentOrg ? currentOrg.title : "미확인";
          }

          return {
            title,
            users: users.filter(user => user)
          }
        })
      dispatch({
        type: FETCH_MESSAGE_USERS,
        payload: message_users
      })
    })
    .catch(e => {
      dispatch(showAlertAction({
        message: "메시지 보낼 유저를 가져오는데 실패했습니다. 잠시후 다시 시도해주세요",
        color: 'danger',
      }))
    })
}
